import { ROOM_1 } from './Exhibition2/room1/data'
import { ROOM_2 } from './Exhibition2/room2/data'
import { ROOM_0 } from './Exhibition2/IntroRoom/data'
import { ROOM_3 } from './Exhibition2/room3/data'
import { ROOM_4 } from './Exhibition2/room4/data'
import { ROOM_5 } from './Exhibition2/room5/data'
import { ROOM_6 } from './Exhibition2/room6/data'
import { ROOM_7 } from './Exhibition2/room7/data'

export const CHAPTERS_ROUTES = ['/shepherd', '/watchmaker', '/wool', '/lighthouse', '/mine', '/honey', '/salt']

export const CHAPTERS = [
  { name: 'welcome', id: 0 },
  { name: 'shepherd', id: 1 },
  { name: 'watchmaker', id: 2 },
  { name: 'wool', id: 3 },
  { name: 'lighthouse', id: 4 },
  { name: 'mine', id: 5 },
  { name: 'honey', id: 6 },
  { name: 'salt', id: 7 },
  { name: 'credits', id: 8 },
]

export const ROOMS = [ROOM_0, ROOM_2, ROOM_4, ROOM_3, ROOM_7, ROOM_1, ROOM_6, ROOM_5]
